import { ApiClientFactory } from './ApiClientFactory';

let clientFactory = new ApiClientFactory();

export const MapClient = {

	getMapSettings(header) {
		return clientFactory.get('map/settings', {}, header, );
	},

	getMapQuest(header) {
		return clientFactory.get('map/quest', {}, header);
	},

	getUserProgress(header) {
		return clientFactory.get('map/user-progress', {}, header);
	},

	getQuestUsers(header) {
		return clientFactory.get('map/quest-users', {}, header);
	}

};